module.exports = require('./commonjs/cache').default;